package amazon.lastmile.inject

import app.nestbridge.domain.identity.api.RemoteUserApiClient
import app.nestbridge.domain.identity.api.UserApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteUserApiClient::class)
public interface AppNestbridgeDomainIdentityApiRemoteUserApiClient {
  @Provides
  public fun provideRemoteUserApiClientUserApiClient(remoteUserApiClient: RemoteUserApiClient): UserApiClient = remoteUserApiClient
}
